import SortPriorityBadge from 'components/Shared/Table/SortPriorityBadge/SortPriorityBadge'

export default SortPriorityBadge
